import { render, staticRenderFns } from "./BulkResendConfirmationEmail.vue?vue&type=template&id=acc95fbc"
import script from "./BulkResendConfirmationEmail.vue?vue&type=script&lang=js"
export * from "./BulkResendConfirmationEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports